import { getToken } from '@/api/auth'
const EntryPool = {
  //[10001] 官网进入
  '10001': async function () {
    const _q = this._query
    const _ctx = this._ctx
    //处理逻辑
    const res = await getToken({ code: _q.code }).catch((err) => {
      console.log('[10001] - getToken - err', err)
    })
    if (res) {
      const { status, token } = res
      _ctx.$store.dispatch('setToken', { token })
      status ? _ctx.$router.push('/') : _ctx.$message.error('当前账号需扫码登录')
    }

    return new Promise((reslove) => {
      reslove(true)
    })
  }
}
class Entry {
  constructor (options = {}) {
    const { url, ctx } = options
    this._ctx = ctx

    this.init()
  }
  async init () {
    if (!this.initEntryQuery().entryCode) return new Error('not find entryCode')
    await this.runHooks()
    // console.log('this.Queryed()',this.Queryed())
  }
  initEntryQuery () {
    const _q = this._ctx.$route.query
    this._query = _q
    this._entrycode = _q.entryCode
    console.log('_q', _q)
    return _q
  }
  runHooks () {
    return EntryPool[this._entrycode].call(this)
  }
}
export default Entry
